import Grid from 'admin/components/atoms/Grid';
import React, { useCallback, useEffect, useState } from 'react';
import styled from 'styled-components';
import { getAccountBalances } from '~/javascripts/admin/actions/account';
import { toQueryParams } from '~/javascripts/admin/utils';
import { toPointExpiresAtFormValue } from '~/javascripts/admin/utils/pointExpiry';
import Pager from '../../../molecules/Pager';

const GridRow = styled(Grid.Container)`
  padding: 6px 0;
`;

const PagerWrapper = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 6px;
`;

const AmountBlock = styled.div`
  min-width: 6em;
  text-align: right;
`;

const UnitBlock = styled.div`
  width: 1em;
  text-align: right;
  display: inline-block;
`;

const Balances = ({ accountId }: { accountId?: string }) => {
  const [balances, setBalances] = useState<Awaited<ReturnType<typeof getAccountBalances>>>();

  const getBalances = useCallback(
    (page = 1) => {
      if (accountId) {
        getAccountBalances(accountId, toQueryParams({ page, per_page: 50 })).then((res) =>
          setBalances(res)
        );
      }
    },
    [accountId]
  );

  const onChangePage = (page: number) => {
    getBalances(page);
  };

  useEffect(() => {
    getBalances();
  }, [accountId, getBalances]);

  if (!balances?.rows?.length) {
    return null;
  }

  return (
    <>
      {balances.rows.map(({ expires_at, money_amount, point_amount }) => (
        <>
          <GridRow key={expires_at}>
            <Grid.Item size={3}>
              {toPointExpiresAtFormValue(expires_at)?.format('YYYY/MM/DD')}
            </Grid.Item>
            <Grid.Item size={9}>
              {[
                { amount: money_amount, unit: '円' },
                { amount: point_amount, unit: 'P' },
              ]
                .filter((i) => !!i.amount)
                .map(({ amount, unit }) => (
                  <AmountBlock>
                    {amount?.toLocaleString()} <UnitBlock>{unit}</UnitBlock>
                  </AmountBlock>
                ))}
            </Grid.Item>
          </GridRow>
          <Grid.Divider margin="0" />
        </>
      ))}

      <PagerWrapper>
        <Pager pagination={balances.pagination} onChangePage={onChangePage} />
      </PagerWrapper>
    </>
  );
};

export default Balances;
